import jwt_decode from 'jwt-decode';
import { SessionTokenProps } from '../../interfaces/session/index';

export function getDecodedToken( token: string ){

    const decodedToken = jwt_decode<SessionTokenProps>(token)
    
    return decodedToken

}

export function getUserIdByToken( token: string ){

    const decodedToken = jwt_decode<SessionTokenProps>(token)
    
    return decodedToken?.uid

}